export default {
    navigationBarTitleText: intl.get('accessoryList.title'),
  };
